import { IModalDescription } from '@cp/shared/modal';
import type { PersonalQualitiesAnswersModalProps } from '../ui/answersModal';
import type { PersonalQualitiesPromptEditModalProps } from '../ui/promptEditModal';
import type { PersonalQualitiesMultiAnalysisModalProps } from '../ui/multiAnalysisModal';

export const PERSONAL_QUALITIES_ANSWERS_MODAL: IModalDescription<PersonalQualitiesAnswersModalProps> = {
  nss: 'client/personal-qualities-answers',
  loader: () => import('../ui/answersModal').then((module) => module.PersonalQualitiesAnswersModal),
};

export const PERSONAL_QUALITIES_PROMPT_EDIT_MODAL: IModalDescription<PersonalQualitiesPromptEditModalProps> = {
  nss: 'client/personal-qualities-prompt-edit',
  loader: () => import('../ui/promptEditModal').then((module) => module.PersonalQualitiesPromptEditModal),
};

export const PERSONAL_QUALITIES_MULTI_ANALYSIS_MODAL: IModalDescription<PersonalQualitiesMultiAnalysisModalProps> = {
  nss: 'client/personal-qualities-multi-analysis',
  loader: () => import('../ui/multiAnalysisModal').then((module) => module.PersonalQualitiesMultiAnalysisModal),
};
